import styled, { css } from 'styled-components';
import { ifProp, palette } from 'styled-tools';

import { OptionalBackgroundButton } from '@calm-web/design-system';

import GridWrapper from '@/components/ui/GridWrapper';

export const Grid = styled(GridWrapper)`
	text-align: left;
	margin: 0;
`;

export const SorryText = styled.div<{ isRevampRedempFlow?: boolean }>`
	margin-top: 0;
	margin-bottom: 24px;
	p,
	ol > li {
		margin-bottom: 24px;
	}
	p,
	li {
		line-height: 150%;
	}

	div {
		text-decoration: underline;
		display: inline;
		cursor: pointer;
	}

	${ifProp(
		'isRevampRedempFlow',
		css`
			ul > li {
				list-style-type: disc;
			}

			font-size: 20px;

			p {
				font-size: 20px;
			}
		`,
	)}
`;

export const SorryButton = styled(OptionalBackgroundButton)`
	color: ${palette('white')};
	background: ${palette('gradientCalmBrand')};
	text-transform: capitalize;
`;

export const UnderlinedLink = styled.a`
	text-decoration: underline;
`;
